<template>
  <div>
    <h2>
      <span class="step-name"> Animal Numbers - Lifestyle/Other </span>
      <comments field-name="heading_animal_numbers_lifestyle_other"></comments>
    </h2>
    <h3>Animal numbers are numbers wintered or expected to be wintered for the consult year</h3>

    <div class="step-section row">
      <div class="col-md-6 col-md-offset-3">
        <radio-input
          label="Interested in joining a lifestyle program"
          :add-email-notification="true"
          @on-change="toggleNotification"
          field-name="lifestyle_wants_join_lifestyle_program"
          :choices="[
            { value: true, display: 'Yes' },
            { value: false, display: 'No' },
          ]"
        >
        </radio-input>
      </div>
    </div>

    <div class="step-section row">
      <div class="col-md-6">
        <h3>Previous Consult</h3>

        <div class="form-group input-box">
          <label>Horses</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_horses"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Pigs</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_pigs"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Alpaca</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_alpaca"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Llama</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_llama"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Goats</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_goats"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Poultry</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_poultry"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Other animals</label>
          <textarea
            rows="5"
            cols="50"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA').lifestyle_other_animals_text"
            disabled
          >
          </textarea>
        </div>
      </div>

      <div class="col-md-6">
        <h3>This Year</h3>

        <number-input label="Horses" field-name="lifestyle_horses"> </number-input>

        <number-input label="Pigs" field-name="lifestyle_pigs"> </number-input>

        <number-input label="Alpaca" field-name="lifestyle_alpaca"> </number-input>

        <number-input label="Llama" field-name="lifestyle_llama"> </number-input>

        <number-input label="Goats" field-name="lifestyle_goats"> </number-input>

        <number-input label="Poultry" field-name="lifestyle_poultry"> </number-input>

        <text-area label="Other animals" field-name="lifestyle_other_animals_text"> </text-area>
      </div>
    </div>
    <hr />
    <div class="step-section row">
      <discussion-points
        title="Poultry"
        comments-field="lifestyle_other_poultry_discussion"
        points="Use, stocking rate, housing arrangement, nutrition, vaccination, worming, health issues, drugs"
      >
      </discussion-points>

      <discussion-points
        title="Alpacas/Llamas"
        comments-field="lifestyle_other_alpacas_llamas_discussion"
        points="Use, stocking rate, housing arrangement, nutrition, vaccination, worming, breeding, castration, health issues, drugs"
      >
      </discussion-points>
      <discussion-points
        title="Goats"
        comments-field="lifestyle_other_goats_discussion"
        points="Use, stocking rate, housing arrangement, nutrition, vaccination, worming, breeding, castration, health issues, drugs"
      >
      </discussion-points>
      <discussion-points
        title="Pigs"
        comments-field="lifestyle_other_pigs_discussion"
        points="Use, stocking rate, housing arrangement, nutrition, vaccination, worming, breeding, castration, health issues, drugs"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <div class="form-group">
        <i
          class="glyphicon glyphicon-envelope"
          aria-hidden="true"
          data-toggle="tooltip"
          data-placement="top"
          title="Email might be generated"
        ></i>

        <span class="form-group">
          <label>Please write any allocations or comments below and these will be emailed to Farm Services</label>

          <comments field-name="lifestyle_other_notes_for_farm_services" @on-change="toggleNotification"></comments>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'AnimalNumbersLifestyleOther',
  mixins: [baseComponent],
  methods: {
    toggleNotification: function ({ fieldName, value }) {
      if (fieldName == 'lifestyle_wants_join_lifestyle_program') {
        this.setEmailNotification({ slug: 'interested-in-joining-a-lifestyle-program', value: value })
      }
      if (fieldName == 'lifestyle_other_notes_for_farm_services') {
        this.setEmailNotification({ slug: 'lifestyle-other-notes-for-farm-services', value: value ? true : false })
      }
    },
  },
}
</script>
